
export enum PaymentStatus {
    PAGAMENTO_REALIZADO = 3,
    CANCELADO = 4,
}